export class TicketReciveMoneyFillter{
    code:string;
    ticketIds:any[]=[];
    hubId:any;
    isCreatedInvoice:boolean;
    empId:any;
    fromDate:any;
    toDate:any;
    pageNumber:any =1;
    pageSize:any =20;
}